module.exports = __webpack_public_path__ + "img/wendu.5de959dc.png";